<template>
  <div>
    <v-data-table
      :items="orgListDataFormatted"
      :headers="headers"
      :loading="loading"
      item-key="orgId"
      :items-per-page="-1"
      dense
    >
      <template v-slot:top>
        <div>
          <h1 align="center">Subscriptions</h1>
          <h3 align="center">{{ new Date().toLocaleString() }}</h3>
        </div>
        <div class="d-flex mb-5">
          <div class="d-flex tabs">
            <v-btn
              class="tab"
              :class="tab === 'all' ? 'tab--active' : ''"
              text
              @click="tab = 'all'"
            >
              All
            </v-btn>
            <v-btn
              class="tab"
              :class="tab === 'subscribed' ? 'tab--active' : ''"
              text
              @click="tab = 'subscribed'"
            >
              Subscribed
            </v-btn>
            <v-btn
              class="tab"
              :class="tab === 'unsubscribed' ? 'tab--active' : ''"
              text
              @click="tab = 'unsubscribed'"
            >
              Unsubscribed
            </v-btn>
          </div>
          <v-btn
            small
            plain
            text
            elevation="0"
            color="transparent"
            class="blue--text text-none hide-mobile export-btn"
            @click="exportCSV"
          >
            <v-icon>mdi-file-download</v-icon>
            Export CSV
          </v-btn>
        </div>
      </template>
      <template #item.linkToStripe="{ item }">
        <div v-if="item.linkToStripe === 'Not Subscribed'">
          {{ item.linkToStripe }}
        </div>
        <a v-else target="_blank" :href="item.linkToStripe"
          >Stripe Subscription</a
        >
      </template>
      <template #header.adminName="{ header }">
        <div class="d-flex">
          <div>
            {{ header.text }}
          </div>
          <v-btn
            class="expand-btn mt-1"
            icon
            @click="adminExpanded = !adminExpanded"
          >
            <v-icon size="18">
              {{ adminExpanded ? "mdi-minus" : "mdi-plus" }}
            </v-icon>
          </v-btn>
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { getOrgListData } from "@/helpers/api";

const headers = [
  {
    text: "Organization Name",
    value: "orgName",
    align: "start",
    divider: true
  },
  {
    text: "Administrative Contact",
    value: "adminName",
    align: "start",
    divider: true,
    sortable: false
  },
  {
    text: "Type",
    value: "subscriptionInterval",
    align: "start",
    divider: true
  },
  {
    text: "Subscriber Since",
    value: "subscriberSince",
    align: "end",
    divider: true
  },
  {
    text: "Renewal Date",
    value: "lastRenewalDate",
    align: "end",
    divider: true
  },
  // {
  //   text: "Last Club Payment Date",
  //   value: "lastPaymentDate",
  //   align: "center",
  //   divider: true
  // },
  {
    text: "Last Amount Paid",
    value: "lastPaymentAmount",
    align: "start",
    divider: true
  },
  {
    text: "Available Licenses",
    value: "licenseCount",
    align: "start",
    divider: true
  },
  {
    text: "Licenses Used",
    value: "teamCount",
    align: "start",
    divider: true
  },
  {
    text: "Unused Licenses",
    value: "unusedLicenses",
    align: "start",
    divider: true
  },
  // {
  //   text: "Price Per Team",
  //   value: "pricePerTeam",
  //   align: "end",
  //   divider: true
  // },
  {
    text: "Monthly Cost per License",
    value: "pricePerTeam",
    align: "start",
    divider: true
  },
  {
    text: "Stripe Dashboard",
    value: "linkToStripe",
    align: "center",
    divider: true
  }
];

export default {
  name: "OrgList.vue",
  data() {
    return {
      orgListData: null,
      orgListDataFormatted: [],
      headers,
      loading: true,
      tab: "all",
      adminExpanded: false
    };
  },
  watch: {
    adminExpanded: function(newVal, oldVal) {
      if (newVal !== oldVal) {
        if (newVal) {
          this.headers = this.headers
            .slice(0, 2)
            .concat([
              {
                text: "Admin Email",
                value: "adminEmail",
                align: "start",
                divider: true
              },
              {
                text: "Admin Phone Number",
                value: "adminPhoneNumber",
                align: "center",
                divider: true
              }
            ])
            .concat(this.headers.slice(2));
        } else {
          if (this.headers.length > 11) {
            this.headers = this.headers
              .slice(0, 2)
              .concat(this.headers.slice(4));
          }
        }
      }
    },
    tab: function(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.fetchOrgListData();
      }
    },
    orgListData: function(newOrgListData, oldOrgListData) {
      const orgListDataFormatted = [];
      if (this.orgListData) {
        this.orgListData.orgListItems.map(i => {
          const x = {};
          if (i.pricePerTeam !== 0) {
            const price = i.pricePerTeam.toString();
            x.pricePerTeam =
              "$" +
              price.slice(0, price.length - 2) +
              "." +
              price.slice(price.length - 2);
          } else {
            x.pricePerTeam = i.pricePerTeam;
          }
          x.orgName = i.orgName;
          x.adminName = i.adminName;
          x.adminEmail = i.adminEmail;
          if (i.subscriptionId != null) {
            x.linkToStripe = `https://dashboard.stripe.com/subscriptions/${i.subscriptionId}`;
          } else {
            x.linkToStripe = "Not Subscribed";
          }
          if (i.adminPhoneNumber) {
            const number = i.adminPhoneNumber;
            x.adminPhoneNumber =
              "(" +
              number.slice(0, 3) +
              ")" +
              number.slice(3, 6) +
              "-" +
              number.slice(6);
          } else {
            x.adminPhoneNumber = i.adminPhoneNumber;
          }
          x.lastPaymentDate = i.lastPaymentDate;
          if (i.lastPaymentAmount != null && i.lastPaymentAmount != 0) {
            const price = i.lastPaymentAmount.toString();
            x.lastPaymentAmount =
              "$" +
              price.slice(0, price.length - 2) +
              "." +
              price.slice(price.length - 2);
          } else {
            x.lastPaymentAmount = i.lastPaymentAmount;
          }
          x.teamCount = i.teamCount;
          x.licenseCount = i.licenseCount;
          x.unusedLicenses = i.licenseCount - i.teamCount;
          x.unusedLicenses = x.unusedLicenses > 0 ? x.unusedLicenses : 0;
          x.subscriptionInterval =
            i.subscriptionInterval != null
              ? i.subscriptionInterval.toLowerCase()
              : null;
          if (i.subscriberSince) {
            x.subscriberSince = i.subscriberSince.slice(0, 10);
          }
          if (i.lastRenewalDate && i.lastRenewalDate !== i.subscriberSince) {
            x.lastRenewalDate = i.lastRenewalDate.slice(0, 10);
          }
          orgListDataFormatted.push(x);
        });
        this.orgListDataFormatted = orgListDataFormatted;
      } else {
        this.orgListDataFormatted = [];
      }
    }
  },
  methods: {
    async fetchOrgListData() {
      this.loading = true;
      this.orgListData = await getOrgListData(this.tab);
      this.loading = false;
    },
    async exportCSV() {
      const rows = [];
      const headerRow = [];
      if (this.headers.length > 11) {
        this.headers.forEach(i => headerRow.push(i.text));
      } else {
        this.headers
          .slice(0, 2)
          .concat([
            {
              text: "Admin Email",
              value: "adminEmail",
              align: "start",
              divider: true
            },
            {
              text: "Admin Phone Number",
              value: "adminPhoneNumber",
              align: "center",
              divider: true
            }
          ])
          .concat(this.headers.slice(2))
          .forEach(i => headerRow.push(i.text));
      }
      rows.push(headerRow);
      this.orgListDataFormatted.forEach(i => {
        const row = [];
        row.push(i.orgName);
        row.push(i.adminName);
        row.push(i.adminEmail);
        row.push(i.adminPhoneNumber);
        row.push(i.subscriptionInterval);
        row.push(i.subscriberSince);
        row.push(i.lastRenewalDate);
        row.push(i.lastPaymentAmount);
        row.push(i.licenseCount);
        row.push(i.teamCount);
        row.push(i.unusedLicenses);
        row.push(i.pricePerTeam);
        row.push(i.linkToStripe);
        rows.push(row);
      });
      const csvContent =
        "data:text/csv;charset=utf-8," + rows.map(e => e.join(",")).join("\n");
      const encodeUri = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", encodeUri);
      link.setAttribute("download", "TeamBot_OrgList.csv");
      document.body.appendChild(link);
      link.click();
    }
  },
  mounted() {
    this.fetchOrgListData();
  }
};
</script>

<style scoped>
.tabs {
  margin: 1vh auto 0 auto;
}
.export-btn {
  position: absolute;
  right: 1vw;
}
.tab {
  margin: 0 1vw 0 1vw;
  text-transform: none !important;
  font-size: 0.8rem;
}
.tab--active {
  color: #1f97ff;
}
.expand-btn {
  height: 1vh;
  width: 1vw;
}
</style>
